export const OFFER_LAYOUT_STANDARD = 'standard';
export const OFFER_LAYOUT_GROUPED_BY_INSTALLMENTS = 'grouped-by-installments';

export function resolveOfferLayout(value) {
  const normalized = String(value || '').trim().toLowerCase();

  if (normalized === OFFER_LAYOUT_GROUPED_BY_INSTALLMENTS) {
    return OFFER_LAYOUT_GROUPED_BY_INSTALLMENTS;
  }

  return OFFER_LAYOUT_STANDARD;
}

export function groupOffersByInstallments(plans) {
  const groups = new Map();

  plans.forEach((plan) => {
    const installments = Number(plan.installments);

    if (!groups.has(installments)) {
      groups.set(installments, []);
    }

    groups.get(installments).push(plan);
  });

  return Array.from(groups.entries())
    .sort(([left], [right]) => left - right)
    .map(([installments, groupPlans]) => ({
      installments,
      plans: groupPlans,
    }));
}
